export const GET_RESTRICTED_ACCOUNT = "GET_RESTRICTED_ACCOUNT";
export const CREATE_RESTRICTED_ACCOUNT = "CREATE_RESTRICTED_ACCOUNT";
export const UPDATE_RESTRICTED_ACCOUNT_STATUS = "UPDATE_RESTRICTED_ACCOUNT_STATUS";
export const DELETE_RESTRICTED_ACCOUNT = "DELETE_RESTRICTED_ACCOUNT";

export const OPEN_RESTRICTED_ACCOUNT_DIALOG = "OPEN_RESTRICTED_ACCOUNT_DIALOG";
export const CLOSE_RESTRICTED_ACCOUNT_DIALOG = "CLOSE_RESTRICTED_ACCOUNT_DIALOG";
